import { useEffect, useState } from "react"
import { ForumPost, WithID } from "../../types/db";
import { ForumPostService } from "../../types/services/forum/ForumService";
import { db } from "../../services/firebase";
import { isLiked } from "../../services/forums";

const forumService = new ForumPostService(db);

/** Takes care of fetching and keeping up to date a specific post */
export const useForumPost = (postId: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [post, setPost] = useState<(WithID<ForumPost> & { isLiked: boolean }) | null>(null)

    useEffect(() => {
        if (!postId) {
            setIsLoading(false);
            setError('');
            setPost(null)
            return;
        }

        setIsLoading(true);
        setError('');

        //register to listening to changes on the data
        return forumService.getDocumentRef(postId)
            .onSnapshot(
                async (snap) => {
                    const dataSnap = ForumPostService.documentToEntity<ForumPost>(snap);
                    if (!dataSnap) {
                        setIsLoading(false);
                        return;
                    }
                    const liked = await isLiked(postId)
                    setPost({
                        ...dataSnap,
                        isLiked: liked,
                    });
                    setIsLoading(false);
                },
                (error) => {
                    setError(error.message)
                    setIsLoading(false)
                })
    }, [postId]);

    return {
        isLoading,
        isError: !!error,
        error,
        data: post
    }
}